/** SHA-256 of a file, computed in the browser so the server can verify the stored bytes; undefined for very large files. */
export async function sha256Hex(file: Blob): Promise<string | undefined> {
  if (file.size > 64 * 1024 * 1024 || !crypto.subtle) return undefined;
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
